import React, {Component, useRef, useState} from 'react';
import { Button, Panel } from "react-bootstrap";
import {notify} from "../../components/common/Notification";
import _ from 'lodash';

export default function ({connectionId}) {
  const inputRef = useRef(null);

  const copyToClipBoard = (button) => {
    inputRef.current.select();
    document.execCommand("copy");
    notify.success('Link copied to clipboard');
  };

  const netDocsQueryParams = {
    ndpage:      '{!Current.Page.URL}',
    ndAttrKey:   '{!Workspace.Base.Attribute.Key}',
    ndBaseKey:   '{!Workspace.Parent.Attribute.Key}',
    ndUserId:    '{!Current.User.GUID}',
    ndUserEmail: '{!Current.User.Email.Address}',
    ndUserName:  '{!Current.User.Name}',
  };

  // NOTE, we don't want URL escaping here since these values are special to netdocs UI.
  // so do not e.g. use URLSearchParams
  const queryString = _.toPairs(netDocsQueryParams).map(item => item.join('='))
    .join('&');

  return (
    <Panel>
      <Panel.Heading componentClass="h3">NetDocuments Docket Display Link</Panel.Heading>
      <Panel.Body>
        <p>
          Copy/Paste this link into any NetDocuments Workspace Overview to utilize the CourtDrive docket for this case
          within NetDocuments.  You can use this link in a workspace template in NetDocuments so it will apply to all
          newly created cases in NetDocuments.
        </p>

        <input
          type='text'
          ref={inputRef}
          value={`https://app.courtdrive.com/rpc/integrations/connections/${connectionId}/netdocuments/case-docket?${queryString}`}
          size="75"
          readonly
        />
        <Button bsStyle='primary' onClick={copyToClipBoard}>Copy</Button>
      </Panel.Body>
    </Panel>
  );
}




// WEBPACK FOOTER //
// ./src/Integrations/connections/NetDocumentsDocketLinkPanel.jsx